function ensureYoutubeAPIReady() {
	return new Promise((resolve, reject) => {
		if (window.YT && window.YT.Player) {
			return resolve();
		}

		let otherYoutubeReadyCb = null;
		if (typeof window.onYouTubeIframeAPIReady !== "undefined") {
			otherYoutubeReadyCb = window.onYouTubeIframeAPIReady;
		}

		window.onYouTubeIframeAPIReady = () => {
			otherYoutubeReadyCb && otherYoutubeReadyCb();
			resolve();
		};

		let script = document.createElement("script");
		script.id = "youtube-iframe-script";
		script.src = "https://www.youtube.com/iframe_api";
		let firstScriptTag = document.getElementsByTagName("script")[0];
		firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
	});
}

function ensureVimeoAPIReady() {
	return new Promise((resolve, reject) => {
		if (window.Vimeo && window.Vimeo.Player) {
			return resolve();
		}

		let script = document.createElement("script");
		script.id = "vimeo-iframe-script";
		script.src = "https://player.vimeo.com/api/player.js";

		// Set up onload event handler
		script.onload = () => {
			// Check if the necessary objects are now available
			if (window.Vimeo && window.Vimeo.Player) {
				resolve();
			} else {
				reject(
					new Error(
						"Vimeo API script loaded, but Vimeo or Vimeo.Player is still not available",
					),
				);
			}
		};

		// Set up onerror event handler
		script.onerror = () => {
			reject(new Error("Error loading Vimeo API script"));
		};

		let firstScriptTag = document.getElementsByTagName("script")[0];
		firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
	});
}

const removePosterImage = (video) => {
	const poster = video.querySelector(".standard-hero-banner__background-image");

	if (poster) {
		poster.style.opacity = 0;
	}
};

const handleIframeVideos = () => {
	const videoCollection = document.getElementsByClassName(
		"standard-hero-banner__background-video-wrapper",
	);

	if (videoCollection) {
		const videoArray = Array.from(videoCollection);

		videoArray.forEach((videoItem) => {
			// handle local videos
			if (videoItem.dataset.videoType === "video-local") {
				const frame = videoItem.getElementsByTagName("video");
				frame[0].addEventListener("play", () => {
					removePosterImage(videoItem);
				});
			}

			// handle youtube videos
			if (videoItem.dataset.videoType === "video-youtube") {
				ensureYoutubeAPIReady().then(() => {
					videoArray.forEach((video, i) => {
						// events if youtube video is loaded
						const frame = video.getElementsByTagName("iframe");
						if (frame.length) {
							const player = new YT.Player(frame[0], {
								events: {
									onReady: () => {
										isPlayerReady = true;
									},
									onStateChange: (e) => {
										if (e.target.getPlayerState() === 1) {
											removePosterImage(video);
										}

										if (e.target.getPlayerState() === 0) {
											e.target.playVideo();
										}
									},
								},
							});
						}
					});
				});
			}

			// handle vimeo videos
			if (videoItem.dataset.videoType === "video-vimeo") {
				ensureVimeoAPIReady().then(() => {
					videoArray.forEach((video, i) => {
						// events if Vimeo video is loaded
						const frame = video.getElementsByTagName("iframe");

						if (frame.length) {
							if (video.dataset.videoType === "video-vimeo") {
								const player = new Vimeo.Player(frame[0]);

								player.on("play", () => {
									removePosterImage(video);
								});
							}
						}
					});
				});
			}
		});
	}
};

const gsapHeroBannerAnimations = () => {
	// Register ScrollToPlugin for smooth scrolling
	gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

	const wrappers = document.querySelectorAll(
		".wp-block-create-block-standard-standard-hero-banner",
	);

	const stickyBanner = (wrapper) => {
		// Check if animations are enabled for this specific wrapper
		const enableAnimations = wrapper.dataset.enableAnimations === "true";

		if (!enableAnimations) {
			return; // Skip animations if disabled
		}

		// Only pin on desktop (non-touch devices)
		if (ScrollTrigger.isTouch) {
			return; // Skip pinning on mobile/touch devices
		}

		const image = wrapper.querySelector(".standard-hero-banner__wrapper");

		if (wrapper && image) {
			// Create ScrollTrigger instance to pin the image
			ScrollTrigger.create({
				trigger: wrapper,
				start: "top",
				end: "bottom",
				pin: image,
				pinSpacing: false,
			});
		}
	};

	wrappers.forEach((wrapper) => {
		stickyBanner(wrapper);
	});
};

const scrollToElement = () => {
	const skipButton = document.querySelectorAll(
		".standard-hero-banner__skip-header",
	);

	if (skipButton?.length) {
		const skipToElement = (elementId) => {
			const element = document.getElementById(elementId);
			if (element) {
				if (window.ScrollSmoother && ScrollSmoother.get()) {
					ScrollSmoother.get().scrollTo(element, true, "top top");
				}
			}
		};

		skipButton.forEach((button) => {
			const elementId = button.dataset.skip;
			button.addEventListener("click", () => skipToElement(elementId));
		});
	}
};

if (document.readyState !== "loading") {
	handleIframeVideos();
	gsapHeroBannerAnimations();
	scrollToElement();
} else {
	document.addEventListener("DOMContentLoaded", handleIframeVideos);
	document.addEventListener("DOMContentLoaded", gsapHeroBannerAnimations);
	document.addEventListener("DOMContentLoaded", scrollToElement);
}
